import React, { useState } from 'react';
import { showError, showSuccess, showWarning } from '../utils/alertas';

const IS_PROD = true;
const API_BASE_URL = IS_PROD ? 'https://sigoapi.jhe-etes.com.br/api' : 'http://localhost:3001/api';

function TrocaSenhaModal({ isOpen, onClose }) {
    const [senhaAtual, setSenhaAtual] = useState('');
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();

        // 1. Validações básicas no Front
        if (novaSenha.length < 6) {
            return showWarning("Atenção", "A nova senha deve ter pelo menos 6 caracteres.");
        }
        if (novaSenha !== confirmarSenha) {
            return showWarning("Atenção", "A confirmação da senha não bate.");
        }

        setLoading(true);
        const token = localStorage.getItem('token');

        try {
            // 2. Chama o Chaveiro (Backend)
            const response = await fetch(`${API_BASE_URL}/usuario/senha`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ senhaAtual, novaSenha })
            });

            const data = await response.json();

            if (response.ok) {
                showSuccess("Sucesso!", data.message);
                // Limpa os campos e fecha
                setSenhaAtual('');
                setNovaSenha('');
                setConfirmarSenha('');
                onClose();
            } else {
                showError("Erro", data.message);
            }

        } catch (error) {
            console.error(error);
            showError("Erro", "Erro de conexão com o servidor.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-slideUp">

                {/* Header */}
                <div className="bg-slate-800 p-4 flex justify-between items-center">
                    <h3 className="text-white font-bold flex items-center gap-2">
                        🔒 Alterar Senha
                    </h3>
                    <button onClick={onClose} className="text-white/50 hover:text-white font-bold">✕</button>
                </div>

                {/* Body */}
                <form onSubmit={handleSubmit} className="p-6 space-y-4">

                    <div>
                        <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Senha Atual</label>
                        <input
                            type="password"
                            required
                            value={senhaAtual}
                            onChange={(e) => setSenhaAtual(e.target.value)}
                            className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:border-sabesp-blue focus:ring-2 focus:ring-blue-100 transition-all"
                            placeholder="Digite sua senha antiga..."
                        />
                    </div>

                    <div className="border-t border-gray-100 my-2"></div>

                    <div>
                        <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Nova Senha</label>
                        <input
                            type="password"
                            required
                            value={novaSenha}
                            onChange={(e) => setNovaSenha(e.target.value)}
                            className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:border-sabesp-blue focus:ring-2 focus:ring-blue-100 transition-all"
                            placeholder="Mínimo 6 caracteres"
                        />
                    </div>

                    <div>
                        <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Confirmar Nova Senha</label>
                        <input
                            type="password"
                            required
                            value={confirmarSenha}
                            onChange={(e) => setConfirmarSenha(e.target.value)}
                            className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:border-sabesp-blue focus:ring-2 focus:ring-blue-100 transition-all"
                            placeholder="Repita a nova senha"
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full py-3 bg-sabesp-blue hover:bg-blue-900 text-white font-bold rounded-xl shadow-lg transition-all disabled:opacity-50 mt-4"
                    >
                        {loading ? 'Atualizando...' : 'Confirmar Troca'}
                    </button>

                </form>
            </div>
        </div>
    );
}

export default TrocaSenhaModal;